/**
 * Resolves the `?tab=` search param to a known tab value.
 *
 * Returns `raw` only when it is one of `validTabs`; otherwise falls back to
 * `fallback`. This prevents a blank content area (and the MUI "invalid Tabs
 * value" warning) when a stale bookmark or hand-edited URL carries a `tab`
 * value that no longer matches any tab on the page.
 */
export const resolveTab = (raw: string | null | undefined, validTabs: string[], fallback: string): string =>
    raw && validTabs.includes(raw) ? raw : fallback
